// extracted by mini-css-extract-plugin
export default {"container":"Emotion_container__TPXEQ","emotion":"Emotion_emotion__oGLKu"};